import React, {Component} from "react"
import styled from "styled-components"

import {Input} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl, FormatMessage} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {CompanyValue} from "@irati/companyvalues/types"
import Icon from "@irati/ui/src/Icon"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "tag"

const schema = (formatMessage: FormatMessage, required?: boolean) =>
  Validation.string(required ? formatMessage({id: "platform.defaultValidation.required"}) : null)

interface Props extends InjectIntl {
  companyValue: CompanyValue
  label?: string
  maxLength?: number
  onChange(property: string, value?: string): void
  placeholder?: string
  required?: boolean
}

class CompanyValuesTag extends Component<Props> {
  static defaultProps = {
    id: "company-values",
    label: null,
    maxLength: 30,
    placeholder: null,
    required: true
  }

  render() {
    const {companyValue, formatMessage, label, onChange, placeholder, required, ...other} = this.props

    return (
      <StyledInput
        addon={{before: <Icon icon="tag" size={24} />}}
        id={id(PROPERTY, this.props)}
        label={label || formatMessage({id: "admin.companyValues.fields.tag.label"})}
        name={PROPERTY}
        onBlur={(value: string) => onChange(PROPERTY, value)}
        onChange={(value: any) => onChange(PROPERTY, value)}
        placeholder={placeholder || formatMessage({id: "admin.companyValues.fields.tag.placeholder"}, {tenantName: "barfoo"})}
        validation={schema(formatMessage, required)}
        value={companyValue[PROPERTY]}
        {...other}
      />
    )
  }
}

export default injectIntl(CompanyValuesTag)
